import Swiper from 'swiper/bundle';

jQuery(function($) {
    const $lightbox = $('.lightbox');
    const $swiperWrapper = $('.lightbox .swiper-container .swiper-wrapper');
    const $swiperThumbsWrapper = $('.lightbox .swiper-thumbs-container .swiper-wrapper');

    let swiper;
    let thumbswiper;

    function openLightbox($container, clickedIndex = 0) {
        $swiperWrapper.empty();
        $swiperThumbsWrapper.empty();

        $container.find('img.lightbox__item').each(function (index) {
            let imgSrc = '';
            if ($(this).attr('data-lazy-src')){
                imgSrc = $(this).attr('data-lazy-src');
            } else {
                imgSrc = $(this).attr('src');
            }
            
            $swiperWrapper.append(`<div class="swiper-slide d-f f-a-c f-j-c br-24 br-0-s o-h"><img class="lightbox__image h-100 w-100 br-24 br-0-s" src="${imgSrc}" alt="Slide ${index + 1}"></div>`);
            $swiperThumbsWrapper.append(`<div class="swiper-slide d-f f-a-c f-j-c br-16 o-h"><img class="cover h-100 w-100" src="${imgSrc}" alt="Slide ${index + 1}"></div>`);
        });

        const totalSlides = $container.find('img.lightbox__item').length;
        $('.light__total-slides').text(totalSlides);

        $lightbox.addClass('active');

        thumbswiper = new Swiper('.lightbox .swiper-thumbs-container', {
            loop: false,
            lazy: true,
            slidesPerView: 8,
            spaceBetween: 16,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            freeMode: true,
            breakpoints: {
                0: { slidesPerView: 3,
                    spaceBetween: 8,
                 },
                768: { slidesPerView: 6 },
                1024: { slidesPerView: 8 }
            },
            on: {
                slideChangeTransitionEnd: function () {
                    const activeIndex = this.activeIndex;
                },
            }
        });

        swiper = new Swiper('.lightbox .swiper-container', {
            loop: false,
            lazy: true,
            spaceBetween: 24,
            slidesPerView: 1,
            navigation: {
                nextEl: '.lightbox__next',
                prevEl: '.lightbox__prev',
            },
            thumbs: {
                swiper: thumbswiper,
            },
            on: {
                init: function(){
                    updateSlideCounter(this.activeIndex + 1, totalSlides);
                },
                slideChange: function() {
                    updateSlideCounter(this.activeIndex + 1, totalSlides);
                }
            }
        });

        
        if (clickedIndex != 0) {
            setTimeout(function(){
                swiper.slideTo(clickedIndex, 0);
                updateSlideCounter(clickedIndex + 1, totalSlides);
            }, 100);   
        }
    }

    function updateSlideCounter(current, total) {
        $('.lightbox__count-slides').text(current);
        $('.light__total-slides').text(total);
    }

    // Original trigger: clicking an image itself
    $('.lightbox__items .lightbox__item').on('click', function () {
        const $closestContainer = $(this).closest('.lightbox__items');
        const clickedIndex = $closestContainer.find('.lightbox__item').index($(this));
        openLightbox($closestContainer, clickedIndex);
    });

    // NEW: when [data-lightbox-id] is clicked
    $('[data-lightbox-id]').on('click', function () {
        const lightboxId = $(this).attr('data-lightbox-id');
        const $targetContainer = $('[data-lightbox="' + lightboxId + '"]');

        if ($targetContainer.length) {
            openLightbox($targetContainer, 0);
        }
    });

    // Close handler
    $('.lightbox__close').on('click', function () {
        $lightbox.removeClass('active');
        if (swiper) swiper.destroy();
        if (thumbswiper) thumbswiper.destroy();
        $(this).siblings('.lightbox__zoom-wrap').removeClass('active');
        $(this).siblings('.swiper-container').removeClass('hide');
    });
});
